import { Component } from '@angular/core';
import { EmpDetailsReportAndDashboard, Header } from '@aptsi-types';
import { DigitalIdentityDashboardService } from './dashboard.service';
import { DigitalIdentityReportService } from '../../reports/reports.service';
import { ActivatedRoute } from '@angular/router';
import { generateAccessiblePatterns } from 'src/app/shared/chart-patterns/chart-patterns';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss']
})
export class DashboardComponent {


  constructor(
    private digitalIdentityDashboardService: DigitalIdentityDashboardService,
    private digitalIdentityReportService: DigitalIdentityReportService,
    private route: ActivatedRoute
  ) {

  }

  reportData: EmpDetailsReportAndDashboard[] = [];

  chartdata: EmpDetailsReportAndDashboard[] = [];

  selectedFilter: 'last_7_days' | 'last_month' | 'all_time' = 'all_time';



  dashBoardCardsData: EmpDetailsReportAndDashboard = null;

  // item.organizationId,
  //       item.organizationName,           
  //       item.totalEmployees,
  //       item.activeEmployees,


  headers: Header[] = [
    {
      name: "Organization Id ",
      property: "organizationId",
      showInDropdown: true,

    },
    {
      name: "Organization Name",
      property: "organizationName",
      showInDropdown: true,

    },
    {
      name: "Total Employees",
      property: "totalEmployees",
      showInDropdown: true,

    },
    {
      name: "Active Employees",
      property: "activeEmployees",
      showInDropdown: true,

    },

  ]


  // async ngOnInit(): Promise<void> {
  //   this.fetchDashboardCardsData();
  //   this.fetchReportData();
  //   this.fetchDashboardChartData();

  // }

  
   ngOnInit(): void {
    const resolved = this.route.snapshot.data['dashboard'];

    this.dashBoardCardsData = resolved.dashBoardData;
    this.reportData = resolved.data["organizationEmployeeSummaryReportDTO"] || [];
    this.chartdata = resolved.chartdata["organizationWiseEmployeeDistributionDTO"] || [];

    // Setup chartData
           this.chartData = {
     labels: this.chartdata.map(item => item.organizationName),
     datasets: [
       {
         label: 'Active',
         data: this.chartdata.map(item => item.activeEmployees),
         backgroundColor: generateAccessiblePatterns(1)[0], // patterned fill
       },
       {
         label: 'Terminated',
         data: this.chartdata.map(item => item.terminatedEmployees),
         backgroundColor: generateAccessiblePatterns(2)[1], // patterned fill
       },
       {
         label: 'Retired',
         data: this.chartdata.map(item => item.retiredEmployees),
         backgroundColor: generateAccessiblePatterns(3)[2], // patterned fill
       }
     ]
   };
  }



  chartData: any = {};

  // async fetchDashboardCardsData() {
  //   try {
  //     const response = await this.digitalIdentityDashboardService.getDiDashboardCardsData().toPromise();

  //     this.dashBoardCardsData = response;

  //     console.log(this.dashBoardCardsData)
  //   } catch (error) {
  //     console.error('Error fetching report data:', error);
  //   }
  // }

  // async fetchReportData() {
  //   try {
  //     const response = await this.digitalIdentityReportService.getDiReports(this.selectedFilter).toPromise();

  //     this.reportData = response["organizationEmployeeSummaryReportDTO"];

  //   } catch (error) {
  //     console.error('Error fetching report data:', error);
  //   }
  // }

  // // chartData: any = {};

  // async fetchDashboardChartData() {
  //   try {
  //     const response = await this.digitalIdentityReportService.getDiChartData(this.selectedFilter).toPromise();
  //     console.log('DI chart response:', response);

  //     // Assuming the structure is correct, updating the mapping to reflect the correct keys
  //     this.chartdata = response["organizationWiseEmployeeDistributionDTO"];
  //     console.log('DI chart data:', this.chartdata);

  //     this.chartData = {
  //       labels: this.chartdata.map(item => item.organizationName),  // Organization names on X-Axis
  //       datasets: [
  //         {
  //           label: 'Active',
  //           data: this.chartdata.map(item => item.activeEmployees),  // Active employees data
  //           backgroundColor: 'rgba(75, 192, 192, 0.6)',  // Active employees color
  //         },
  //         {
  //           label: 'Terminated',
  //           data: this.chartdata.map(item => item.terminatedEmployees),  // Terminated employees data
  //           backgroundColor: 'rgba(255, 99, 132, 0.6)',  // Terminated employees color
  //         },
  //         {
  //           label: 'Retired',
  //           data: this.chartdata.map(item => item.retiredEmployees),  // Retired employees data
  //           backgroundColor: 'rgba(153, 102, 255, 0.6)',  // Retired employees color
  //         }
  //       ]
  //     };
  //   } catch (error) {
  //     console.error('Error fetching chart data:', error);
  //   }
  // }

        // Chart options (Stacked Bar Chart)
  chartOptions = {
    responsive: true,
    plugins: {
      legend: {
        position: 'top',
      },
      tooltip: {
        enabled: true,
      }
    },
    scales: {
      x: {
        title: {
          display: true,
          text: 'Organization',
        },
      },
      y: {
        title: {
          display: true,
          text: 'Number of Employees',
        },
        min: 0,
        stacked: false,  // Enable stacking for bars
      },
    },
  };


}
